import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@cmp-src/primitives/dropdown-menu";
import { MapIcon } from "@heroicons/react/outline";
import { ClockIcon, PencilIcon, TrashIcon } from "@heroicons/react/solid";

type ReservationActionParams = {
  onEditReservation: () => void;
  currentUserCanEdit: undefined | boolean;
  currentUserCanCancel: undefined | boolean;
  embedded: boolean;
  onViewOnMap: () => void;
  onCancelReservation: () => void;
  onExtendReservation?: () => void;
  isCheckedIn?: boolean;
  children: React.ReactNode;
  position:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "top-end"
    | "top-start"
    | "top";
};

export const ReservationActions = ({
  currentUserCanEdit,
  embedded,
  onCancelReservation,
  onEditReservation,
  onViewOnMap,
  onExtendReservation,
  isCheckedIn,
  currentUserCanCancel,
  children,
  position
}: ReservationActionParams) => {
  const [side, align] = position.includes("-")
    ? (position.split("-") as ["bottom" | "top", "end" | "start"])
    : [position as "bottom" | "top", "center" as const];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent
        side={side}
        align={align === "center" ? undefined : align}
        className="w-[200px]"
      >
        <DropdownMenuItem
          onSelect={onEditReservation}
          disabled={!currentUserCanEdit}
          className={!currentUserCanEdit ? "text-neutral-300" : ""}
        >
          <PencilIcon className="mr-2 h-5 w-5 text-tertiary" />
          Edit Reservation
        </DropdownMenuItem>
        {isCheckedIn && onExtendReservation ? (
          <DropdownMenuItem onSelect={onExtendReservation}>
            <ClockIcon className="mr-2 h-5 w-5 text-tertiary" />
            Extend Reservation
          </DropdownMenuItem>
        ) : null}
        {/* Temporarily hide until we migrate URL state to context due to Teams iframe restriction */}
        {embedded ? null : (
          <DropdownMenuItem onSelect={onViewOnMap}>
            <MapIcon className="mr-2 h-5 w-5 text-tertiary" />
            View on Map
          </DropdownMenuItem>
        )}
        {currentUserCanCancel ? (
          <DropdownMenuItem onSelect={onCancelReservation}>
            <TrashIcon className="mr-2 h-5 w-5 text-tertiary" />
            Cancel Reservation
          </DropdownMenuItem>
        ) : null}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
